export enum CarModels {
  POLESTAR_2 = "Polestar 2",
  POLESTAR_3 = "Polestar 3",
  POLESTAR_4 = "Polestar 4",
  POLESTAR_5 = "Polestar 5"
}
